<!-- 最小线宽线距 -->
<template>
  <BaseFormItem2
    :unit="fields.unit"
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup2 v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup2>
    <img slot="other" :src="require('@@/assets/img/pcb/lineweight_view.jpg')" />
  </BaseFormItem2>
</template>

<script>
import { getALUFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: Number,
      default: 6
    },
    // 外层铜厚
    copper: {
      type: Number,
      default: 1
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getALUFields('lineweight')
    },
    options() {
      const { val, fields, copper } = this
      const options = fields.options
      // 最小限制
      let disabledOptions = {
        1: 6,
        2: 7,
        3: 10,
        4: 10,
      }[copper]
      
      // 如果当前项被禁用
      if (val < disabledOptions) {
        // 选中对应的默认值
        this.changeVal({ 1: 6, 2: 7, 3: 10, 4: 10 }[copper])
      }
      
      return options.map(item => ({...item, disabled: item.value < disabledOptions }))
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    }
  },
  methods: {
    handleEmit() {
      const { val, value } = this
      this.$emit('input', val)
      if (val != value) {
        this.$emit('change', val)
      }
    },
    // 修改最小线宽/线距
    changeVal(val) {
      if (this.initPcbParamsChange) return
      this.$topWarning.mergeFields(this.fields.label)
      this.val = val
      this.handleEmit()
    },
  }
}
</script>

<style lang="scss" scoped>
</style>